const AccountCrudModalLangKey = [
	'title_create',
	'title_edit',
	'title_clone',
	'title_deleted',
	'title_remove_single',
	'title_remove_multiple',
	'title_remove_multiple_cnt',
	'field_email_label',
	'field_email_placeholder',
	'field_is_active_label',
	'field_is_active_placeholder',
	'field_is_fired_label',
	'field_role_label',
	'field_role_placeholder',
	'field_login_label',
	'field_login_placeholder',
	'field_password_label',
	'field_password_placeholder',
	'field_kt_group_label',
	'field_kt_group_placeholder',
	'field_date_registered_label',
	'field_date_registered_placeholder',
	'msg_remove_confirm',
	'msg_resurrect_success',
	'msg_resurrect_error',
	'btn_create',
	'btn_update',
	'btn_clone',
	'btn_remove',
	'btn_close'
] as const

type IAccountCrudModalLangKey = typeof AccountCrudModalLangKey[number]

export type IAccountCrudModalLang = {
	account_crud_modal: Record<IAccountCrudModalLangKey, string>
}

const langEntries = AccountCrudModalLangKey.map(
	(key: IAccountCrudModalLangKey) => [key, `account_crud_modal.${key}`]
)

const langObj: Record<IAccountCrudModalLangKey, string> = Object.fromEntries(langEntries)

export const ACCOUNT_CRUD_MODAL_LANG_KEY: IAccountCrudModalLang = {
	account_crud_modal: langObj
}